import React from 'react';
import IntroDetail from '../components/introDetail';
import Seperator from '../components/seperator';
import Container from '@material-ui/core/Container';
import { useStaticQuery, graphql } from 'gatsby';
import ResponsiveLayout from '../components/responsiveLayout';
import Hero from '../components/hero';

// import Foreword from '../sections/Foreword/Foreword';
import Partnership2019 from '../sections/Foreword/Partnership2019';
import TogetherForZeroHunger from '../sections/Foreword/TogetherForZeroHunger';

import SavingLives from '../components/sections/savingLivesSection';
import BringingHope from '../components/sections/bringingHopeSection';
import Map from '../components/sections/mapSection';
import ChangingLives from '../components/sections/changingLivesSection';
import Innovation from '../components/sections/innovationSection';
import FundingFigures from '../components/sections/fundingFiguresSection';
import GlobalReport from '../components/sections/globalReportSection';
import NexusTwo from '../components/sections/nexusTwo';
import NexusOne from '../components/sections/NexusOne';

import Foreword from '../components/sections/forewordSection';

import StoryOne from '../components/sections/StoryOne';
import StoryTwo from '../components/sections/StoryTwo';

const ReportPage = () => {
  const data = useStaticQuery(graphql`
    query {
      gabriela: file(relativePath: { eq: "gabriela.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mamatsela: file(relativePath: { eq: "mamatsela.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wfpEuPartnership: file(relativePath: { eq: "wfpEuPartnership.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <ResponsiveLayout>
      <Hero />
      <div id="foreword">
        <Container>
          <Foreword />
        </Container>
        <IntroDetail title="TOGETHER FOR ZERO HUNGER" color="#db1c67" image={data.gabriela} copyText='WFP/Gabriela Vivacqua'>
          <TogetherForZeroHunger />
        </IntroDetail>
        <IntroDetail
          title="WFP-EU PARTNERSHIP IN 2019"
          color="#1c4967"
          image={data.wfpEuPartnership}
          copyText='European Union, 2020'
        >
          <Partnership2019 />
        </IntroDetail>
      </div>
      <div id="fundingfigures">
        <Container>
          <FundingFigures />
        </Container>
      </div>

      <div id="globalreportfoodcrises">
        <GlobalReport />
      </div>


      <div id="savinglives">
        <SavingLives />
      </div>
      <div id="fatou">
        <StoryOne />
      </div>

      <div id="bringinghope">
        <BringingHope />
      </div>
      <div id="map">
        <Map />
      </div>
      <div id="changinglives">
        <Container>
          <ChangingLives />
        </Container>
      </div>

      <div id="joyce">
        <StoryTwo />
      </div>
      <div id="kenya">
        <NexusTwo />
      </div>

      <div id="chad">
        <NexusOne />
      </div>

      <div id="innovation">
        <Container>
          <Innovation />
        </Container>
      </div>
    </ResponsiveLayout>
  );
};

export default ReportPage;
